
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts-under-50",
      function () {
        return require("private-next-pages/gifts-under-50.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts-under-50"])
      });
    }
  